import ClientList from './client.list';
import ClientDetail from './client.detail';
import ClientCreate from './client.create';

export const ClientStores = {
  list: ClientList,
  detail: ClientDetail,
  create: ClientCreate,
};
